module.exports = {"_id":"English (US)","login":{"cta":"Please login with your email and password","Email":"E-mail","Password":"Password","emailHint":"Email","passwordHint":"Password","button":"Login"},"pageNotSupported":"Oops! It seems that this page is not supported.","clear.cancel":"Clear","clear.default":"Default"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/locales/en-US.json
// module id = 0TFE
// module chunks = 13 14